import React, {ErrorInfo} from 'react';
import Box from '@material-ui/core/Box';
import { Button } from '@material-ui/core';

class AppErrorBoundary extends React.Component<{location:any}, {hasError: boolean}> {
  constructor(props: any) {
    super(props);
    this.state = {hasError: false};
  }

  static getDerivedStateFromError() {
    // Update state so the next render will show the fallback UI.
    return {hasError: true};
  }

  componentDidCatch(error: Error, errorInfo: ErrorInfo) {
    // You can also log the error to an error reporting service
    console.log('errorInfo: ', errorInfo);
    // logErrorToMyService(error, errorInfo);
  }

  componentDidUpdate(prevProps:any){
    if (this.props.location.pathname !== prevProps.location.pathname) {
      this.setState({hasError:false})
    }
  }
  render() {
    if (this.state.hasError) {
      return (console.error(`[st] [error] BREAKING APP ERROR`),
        <Box
          display='flex'
          alignItems='center'
          flexDirection='column'
          justifyContent='center'
          flex={1}>
          <img src={'/assets/images/error.png'} alt='Error Info' />
          <Box component='h2' fontSize={30} mt={4}>
            Ah! Something went wrong.
          </Box>
          <Box fontSize={18} textAlign='center'>
            Brace yourself till we get the error fixed.
          </Box>
          <Box fontSize={18} textAlign='center'>
            You may also refresh the page or try again later.
          </Box>
          <Box component='div' mt={4}>
            <Button
              variant='contained'
              color='secondary'
              size='small'
              onClick={()=>{
                this.setState({hasError:false});
                window.location.reload();
              }}>
              Reload
            </Button>
          </Box>
        </Box>
      );
    } else {
      return this.props.children;
    }
  }
}

export default AppErrorBoundary;
